export default {
    install: (app, options) => {        
        app.config.globalProperties.$consoleLog = $consoleLog;
        app.provide('SystemUtil', options);
    }
}



export function $consoleLog(data1,data2){
    
    if(data2){
        //console.log(data1,data2);
    }else{
        //console.log(data1);
    }
    
    
}

